<template>
    <Modal v-model="currValue" :title="title" :scrollable="true" width="400">
        <Spin size="large" fix v-if="loading"></Spin>
        <Form ref="form" :model="formData" :label-width="100">

            <Row>
                <Col span="24">
                    <FormItem label="环保代码" prop="epNo">
                        <Input v-model="formData.epNo" placeholder="环保代码"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
              <Col>
                <div class="form-tip">如果平台已经存在机械数据，会被市平台数据覆盖，不存在则直接添加</div>
              </Col>
            </Row>
        </Form>

        <div slot="footer">
            <Button @click="currValue=false">取消</Button>
            <Button type="primary" @click="handleSubmit">下载</Button>
        </div>
    </Modal>
</template>

<script>
    import iEquip from "@/module/main/api/iEquip";
    import modalHelper from "@/mixins/modalHelper";
    import _don from "@/libs/doson";

    const formModal = {
        epNo:null
    };

    export default {
        name: "download-city",
        mixins: [modalHelper],
        data() {
            return {
                formData: _don.cloneWithModal(formModal),
                title: '市平台机械数据下载'
            }
        },
        activated() {
            this.init();
        },
        methods: {
            init() {

            },
            setFormData() {

            },
            async handleSubmit() {
                if (!this.formData.epNo) {
                  this.$Message.error('请填写环保代码')
                  return
                }

                // 提交
                iEquip.downloadCity(this.formData.epNo).then(() => {
                    this.$Message.success('操作成功');
                    this.$emit('on-success', null);
                    this.currValue = false;
                }).loadingSwitch(this, 'loading');
            },
        },
        computed: {
        },
        watch:{

        }
    }
</script>

<style scoped>
    .form-tip {
        color:#ff0000;
        font-size:14px;
        line-height:20px;
    }
</style>
